import React from 'react';
import { Grid } from '@mui/material';
import CzyLoaderZiggy from './CzyLoaderZiggy';

const loaderBgCss: React.CSSProperties = {
  width: '122px',
  height: '100px',
};

const loaderWrapperCss: React.CSSProperties = {
  position: 'absolute',
  top: 240,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 99,
};

const CzyLoader: React.FC = () => {
  return (
    <div style={loaderWrapperCss}>
      <Grid container justifyContent="center">
        <Grid item>
          <div style={loaderBgCss}>
            <CzyLoaderZiggy />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default CzyLoader;
